import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import Header4 from '../../../../../Header/Header4';
import HomeHearder from 'src/components/Pages/Home/NewHome/HomeHearder'
import { MainBottom } from 'src/components/Pages/Guide/component/index'
import { unitsList } from 'src/components/Pages/Guide/component/Datas/normalDatas'
import './style.css'
function AbourUs(props) {
    const { data } = props;
    const cardList = [
        "通过产业化专项支持，开展自主遥感卫星数据标准研制，完善标准体系的建设，推进自主遥感卫星数据共享。",
        "通过建成的自主遥感卫星接收处理设备、数据产品和信息产品加工核心软件及遥感卫星应用平台软件，支持数据规模化生产和业务化应用，促进自主遥感卫星数据源利用率的提升。",
        "通过建成的试验场真实性检验平台，为实验室研发任务和产业化应用提供试验验证支撑手段。",
        "结合产业化专项应用示范任务和自主遥感卫星相关科研试验项目，进行技术成果星地系统试用，开展行业、区域、公众典型应用示范，推动遥感卫星应用产业发展。"
    ];
    return (
        <div className='Home_Introduce' >
            <div className='Home_IntroduceMain' id='Home_IntroduceMain'>
                {/* <Header4></Header4> */}
                <div className='Home_IntroduceTitle'>
                    {props.loginObj && props.loginObj.login && props.loginObj.token !== undefined
                        ?
                        <Header4 />
                        :
                        <HomeHearder />
                    }
                </div>
                <div className='Home_IntroduceMainScroll' >
                    <div className='Home_IntroduceContent'>
                        <div className='Home_IntroduceContentMain'>
                            <div className='Home_IntroduceContentLeft'>

                                <div className='Home_SpaceBasedPlan'>
                                    <div className='Home_SpaceBasedPlan_MainTitle'>陆地观测卫星共性应用支撑服务网</div>
                                    <div className='Home_SpaceBasedPlan_FirstMain'>
                                        <div className='Home_SpaceBasedPlan_MainIntroduceText'>遥感卫星应用国家工程实验室于2008年11月28日获得国家发改委批复（发改办高技[2008]2635号）正式立项，以中国科学院遥感与数字地球研究所作为项目法人单位，联合北京二十一世纪空间技术应用股份有限公司共同进行建设，是目前我国遥感领域唯一的国家工程实验室。</div>
                                        <div className='Home_SpaceBasedPlan_MainIntroduceText'>2013年11月实验室完成全部建设任务通过验收。 2016年8月，国家工程实验室与深圳市政府共建中科遥感（深圳）卫星应用创新研究院，进一步完善遥感技术创新链和产业链，发展空间技术与应用重大科技基础设施，提升区域遥感技术创新能力，从而带动我国卫星应用综合产业的整体发展。</div>
                                    </div>
                                    <div className='Home_SpaceBasedPlan_MainTitle'>使命与任务</div>
                                    <div className='Home_SpaceBasedPlan_FirstMain'>
                                        <div className='Home_SpaceBasedPlan_MainIntroduceText'>实验室针对国家大力发展遥感卫星应用技术与工程的战略需求，立足国家的卫星应用产业发展规划，以发改委提出的促进卫星遥感信息消费为主要目标，完善自主遥感卫星应用标准化体系建设，形成从遥感数据获取、处理、信息产品、应用技术到行业与区域应用示范以及产业化推广完整的遥感应用技术体系，建立遥感应用产业化创新价值链；</div>
                                        <div className='Home_SpaceBasedPlan_MainIntroduceText'>进而促进遥感卫星产业化技术开发、产业结构优化升级、产业技术标准研制、培养工程技术创新人才、促进重大科技成果应用，为我国遥感卫星应用产业提供全方位的技术支撑。</div>
                                        <div className='Home_SpaceBasedPlan_MainIntroduceText'>根据国家工程实验室的建设目标、任务和定位，围绕促进遥感卫星应用产业链的形成和有序、协调发展，遥感卫星应用国家工程实验室主要任务为：</div>
                                        <div className='AbourUsCardList'>
                                            {cardList.map((item, index) => {
                                                return <AbourUsCard data={item} index={index+1} />
                                            })}
                                        </div>
                                        <div className='Home_SpaceBasedPlan_MainIntroduceText'>实验室突破了遥感卫星业务化应用中卫星接收站网远程调度与管理、多星多源数据自动化处理等关键技术，完成1450平米办公场地的改建、150节点网络化工作平台的建设、3类遥感卫星数据接收设备的研制、4类遥感卫星数据处理系统的建设、4类遥感卫星信息产品加工系统的建设、4类遥感卫星应用平台软件的建设、4类遥感卫星数据和产品验证测试系统的建设、11项遥感数据与服务标准的制定，获得国家、院（省）部级奖14项。</div>
                                    </div>
                                    <div className='Home_SpaceBasedPlan_MainTitle'>人才配置</div>
                                    <div className='Home_SpaceBasedPlan_FirstMain'>
                                        <div className='Home_SpaceBasedPlan_MainIntroduceText'>实验室在组织、机构建设方面，通过人才引进与人才联合培养等方式，切实加强人才队伍建设，进一步建立健全组织体构，明确部门人员配置和职责，形成组织结构健全、工作人员责权分明、整体运转高效的组织机构。实验室岗位聘用人员102人，项目聘用人员42人，其中正高级职称13人，副高级职称30人，其他各类研究人员及学生100余人。</div>
                                        <div className='Home_SpaceBasedPlan_MainIntroduceText'>实验室从应用层面带动需求论证、应用成效反馈，对遥感载荷的实际性能进行评价，并推进我国遥感领域标准规范的研究、建立和实施，从而推动遥感载荷设计的标准化、科学化，更贴合实际需要，可望较大幅度的降低设计成本，实现系统间的耦合性和继承性，提高数据接收的可靠性，降低系统维护的难度，形成有利于我国自主遥感卫星规模化、工业化发展的局面，有利于我国建立起大型系列或星座的卫星群，以适应我国卫星应用广泛普适的发展趋势。同时，实验室还紧密结合应用需求，并将研究成果运用到生产中去，实现遥感应用的系统化、规模化，推动卫星遥感应用技术的发展。</div>
                                    </div>
                                    <div className='Home_SpaceBasedPlan_MainTitle'>学术成果和社会效应</div>
                                    <div className='Home_SpaceBasedPlan_FirstMain'>
                                        <div className='Home_SpaceBasedPlan_MainIntroduceText'>实验室在基础研究、工程化应用方面取得了突破，获多种成果，发表国内外核心期刊文章共100篇，软件著作权登记56项，申请专利共166项，在推动遥感卫星应用技术发展方面做出了贡献。</div>
                                        <div className='Home_SpaceBasedPlan_MainIntroduceText'>实验室围绕促进卫星应用产业的有序、协调发展，建立了我国遥感卫星应用共性技术开发和产业化的试验验证平台和关键产品，为国土、水利、农业、林业、海洋等行业部门提供了遥感应用服务并开展了应用示范，扩展了信息加工和增值服务，产生了巨大的经济效益。实验室的建设对推动我国遥感产业结构的调整、遥感资源整合及空间信息服务业整体水平的提升等方面具有重要意义，产生了重大的社会效益。</div>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                    <MainBottom data={unitsList} />
                </div>
            </div>
        </div>
    )
}

const AbourUsCard = (props) => {
    const { data, index } = props;
    return (
        <div className='AbourUsCard'>
            <div className='AbourUsCard_Index'>{index}</div>
            <div className='AbourUsCard_Introduce'>{data}</div>
        </div>
    )
}

const mapState = (state) => ({
    loginObj: state.userReducer.get('loginObj').toJS(),
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch) => ({
})
export default connect(mapState, mapDispatch)(AbourUs);